import { airtableEventAdapter } from './airtableEventAdapter';
import { ticketmasterEventAdapter } from './ticketmasterEventAdapter';
import { showUtils } from './eventAdapter';
import type { AirtableEvent, TicketmasterEvent } from '../../types/shared/event';

export {
  airtableEventAdapter,
  ticketmasterEventAdapter,
  showUtils
};

// Type guard pour vérifier la source d'un événement
export const isAirtableEvent = (event: any): event is AirtableEvent => {
  return event?.source === 'airtable';
};

export const isTicketmasterEvent = (event: any): event is TicketmasterEvent => {
  return event?.source === 'ticketmaster';
};

// Fonction utilitaire pour obtenir l'adaptateur approprié
export const getEventAdapter = (source: 'airtable' | 'ticketmaster' | 'standard' | undefined) => {
  switch (source) {
    case 'airtable':
      return airtableEventAdapter;
    case 'ticketmaster':
      return ticketmasterEventAdapter;
    case 'standard':
    case undefined:
      // Pour les éléments standard, on utilise l'adaptateur Airtable pour la traduction
      return airtableEventAdapter;
    default:
      throw new Error(`Unknown event source: ${source}`);
  }
};